import { Operation } from '../services/operations';

export interface ICollection<T> {
  add(items: T | null | undefined): void;
  addRange(items: T[]): void;
  remove(index: number): void;
  getItem(index: number): T;
  list(): T[];
  count(): number;
  hasItems(): boolean;
  sort(): this;
  sortByObjectProperty(property: string): this;
  distinct(): Collection<T>;
  distinctByObjectProperty(property: string): Collection<T>;
  distinctByHashExpression(func: (i: T) => string): Collection<T>;
  map(func: (i: T) => any): Collection<any>;
  filter(func: (i: T) => any): Collection<T>;
}

export class Collection<T> implements ICollection<T> {
  private items: T[] = [];
  constructor(items?: T[] | null | undefined, item?: T | null | undefined) {
    this.addRange(items);
    this.add(item);
  }

  public add = (item: T | null | undefined) => {
    if (item !== null && item !== undefined) this.items.push(item);
  };

  public addRange = (items: T[] | null | undefined) => {
    if (items !== null && items !== undefined) {
      this.items.push(...items);
    }
  };

  public remove = (index: number) => this.items.splice(index, 1);

  public getItem = (index: number): T => this.items[index];

  public list = (): T[] => this.items;

  public count = (): number => this.items.length;

  public hasItems = (): boolean => this.count() > 0;

  public sort = (): this => {
    this.items = Operation.ArraySort(this.items);
    return this;
  };

  public sortByObjectProperty = (property: string): this => {
    this.items = Operation.ArraySortBy(this.items, property);
    return this;
  };

  public distinct = () => new Collection(Operation.ArrayDistinct(this.items));

  public distinctByObjectProperty = (property: string) =>
    new Collection(Operation.ArrayDistinctBy(this.items, property));

  public distinctByHashExpression = (func: (i: T) => string) =>
    new Collection(Operation.ArrayDistinctWithExpression(this.items, func));

  public map = (func: (i: T) => any) => new Collection(this.items.map(func));

  public filter = (func: (i: T) => any) => new Collection(this.items.filter(func));
}
